import { lazy } from 'react';

// Monitoring Alerts (Monitoring & Alerting)
// One canonical Workbench cockpit owns alert operations and policy evidence.
export const MonitoringDashboard = lazy(() => import('@/capabilities/monitoring-alerts/pages/Monitoring'));

export const AlertRulesWorkspace = lazy(() =>
  import('@/capabilities/monitoring-alerts/pages/AlertRulesTab').then((module) => ({
    default: module.AlertRulesTab,
  }))
);

export const DeduplicationWorkspace = lazy(() =>
  import('@/capabilities/monitoring-alerts/pages/DedupRulesTab').then((module) => ({
    default: module.DedupRulesTab,
  }))
);

export const CorrelationWorkspace = lazy(() =>
  import('@/capabilities/monitoring-alerts/pages/CorrelationTab').then((module) => ({
    default: module.CorrelationTab,
  }))
);


export const ChannelsWorkspace = lazy(() =>
  import('@/capabilities/monitoring-alerts/pages/ChannelsWorkspace').then((module) => ({
    default: module.ChannelsWorkspace,
  }))
);
